import React from 'react'
import { EncounterBundle } from '../../../../types/FHIRTypes/Bundle'
import EncounterList from './EncounterList'
import { EncounterEntry } from '../../../../types/FHIRTypes/Entry'
import EncounterDetail from './EncounterDetail'

type EncountersProps = {
    page: string | undefined;
    isFetching: boolean;
    encounterDetailId: string | undefined;
    encounterData: EncounterBundle | undefined;
    handleChangePage: (page: number) => void
    totalPages: number;
    currentPage: number;
}

const Encounters: React.FC<EncountersProps> = ({ encounterDetailId, page, encounterData, isFetching, handleChangePage, totalPages, currentPage }) => {
    const encounters = (encounterData?.entry?.filter((entry) => entry.resource.resourceType === 'Encounter') || []) as EncounterEntry[]

    return (
        <>
            {
                encounterDetailId && page === 'Encounter' ? (
                    <EncounterDetail
                        encounterDetailId={encounterDetailId}
                    />
                ) :
                    <EncounterList
                        data={encounterData}
                        encounters={encounters}
                        isFetching={isFetching}
                        handleChangePage={handleChangePage}
                        totalPages={totalPages}
                        currentPage={currentPage}
                    />
            }
        </>
    )
}

export default Encounters